<template>
  <div id="container" class="gnb_pdt">
    <div class="title_wrap"><h1>서비스 이용내역관리</h1></div>
    <common-area-search
        :row="1"
        :colspan="2"
        @search="commonOnChangeEvent"
        @clear="cleanSearchDataEvent"
    >
      <template v-slot:R1_C1>
        <label>회사명</label>
        <ul>
          <input
              ref="cmpyNmRef"
              :placeholder="'회사명'"
              class="k-textbox w100"
              @keyup.enter="commonOnChangeEvent"
          />
        </ul>
      </template>
    </common-area-search>
    <!-- //검색 영역 -->

    <section>
      <div class="contents_top_sec">
        <div class="c_t_button_wrap fl">
          <button @click="$refs.paymentWindowRef.kendoWidget().center().open()" class="mid_btn orange mr5 ">이용내역정산</button>
        </div>
        <div class="c_t_button_wrap fr">
          <button class="mid_btn" @click="onClickExcelDownload"><i class="download_icon"></i>엑셀 다운로드</button>
        </div>
      </div>

      <div class="content_list">
        <!-- Kendo 영역 -->
        <kendo-grid ref="gridRef"
                    style="cursor: pointer"
                    :data-source="computedPaymentGridRows"
                    :navigatable="false"
                    :sortable-mode="'multiple'"
                    :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                    :reorderable="true"
                    :column-menu="false"
                    :resizable="true"
                    :selectable="'row'"
                    :columns="gridColumns"
                    :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
                    @change="onChangeGrid"
        />
        <!-- Kendo 영역 끝 -->
      </div>
    </section>
    <kendo-window
        ref="paymentDetailInfoWindowRef"
        :title="'이용내역 정산'"
        :modal="true"
        :width="'400px'"
        style="display:none; min-height: 30px;"
        @open="e=>{this.isPaymentDetailInfoWindowOpen = true}"
        @close="e=>{this.isPaymentDetailInfoWindowOpen = false}"
    >
      <table class="basic_table" border="0" cellspacing="0" cellpadding="0">
        <colgroup>
          <col width="*">
          <col width="*">
          <col width="*">
        </colgroup>
        <tbody>
        <tr>
          <th>구분</th>
          <th>이용 건수</th>
          <th>금액</th>
        </tr>
        <tr v-for="item in paymentDetailInfo.amountList">
          <td>{{item.svcDtlNm}}</td>
          <td class="txt_r">{{item.unitCnt | comma}} {{item.svcDtlBillCdNm}} </td>
          <td class="txt_r">{{item.finalAmount | comma}} 원</td>
        </tr>
        <tr>
          <td colspan="2">합계</td>
          <td class="txt_r">{{ paymentDetailInfo.totalAmount | comma }} 원</td>
        </tr>
        </tbody>
      </table>
    </kendo-window>
    <kendo-window
        ref="paymentWindowRef"
        :title="'이용내역 정산'"
        :modal="true"
        :width="'400px'"
        style="display:none; min-height: 30px;"
        @open="e=>{this.isPaymentWindowOpen = true}"
        @close="e=>{this.isPaymentWindowOpen = false
                    this.paymentCmpyCd = null
                    this.paymentDtVModel = null}"
    >
      <div v-if="isPaymentWindowOpen">
        <ul>
          <li>
            <label>회사</label>
            <common-multi-drop-down
                ref="paymentCmpyCdRef"
                v-model="paymentCmpyCd"
                class="w100"
                :params="{searchCmpyGbnGrup : [Constant.efs.cmpyGbn.CLIENT_COMPANY]}"
                :url="`${ApiConfig.efsDomain}/efs/drop-down/company`"
                :data-value-field="'cmpyCd'"
                :data-text-field="'cmpyNm'"
                :placeholder="'회사선택'"
            ></common-multi-drop-down>
          </li>
          <li class="mt10">
            <label>정산년월</label>
            <kendo-datepicker
                ref="paymentDtRef"
                class="w100"
                v-model="paymentDtVModel"
                depth= "year"
                start= "year"
                :max="new Date()"
                :format="'yyyy/MM'"
                :placeholder="'년/월'"
            ></kendo-datepicker>
          </li>
        </ul>
        <div class="button_area w50">
          <ul>
            <li>
              <button @click="$refs.paymentWindowRef.kendoWidget().close()" class="mid_btn">취소</button>
            </li>
            <li>
              <button @click="onClickPayment" class="mid_btn orange">저장</button>
            </li>
          </ul>
        </div>
      </div>
    </kendo-window>
  </div>
</template>

<script>
import EtnersCommonUtil from '@ebmp-fe-common-module/module/src/common/etners.common.util'
import EtnersDateTimeUtil from '@ebmp-fe-common-module/module/src/common/etners.datetime.util'
import EtnersEfsUtil from '@/common/etners.efs.util'
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'
import { saveExcel } from '@progress/kendo-vue-excel-export'
import Constant from '@/common/constant'

export default {
  name: 'ServicePaymentManageList',
  computed: {
    computedPaymentGridRows: function () {
      const vm = this

      const gridDataSource = new kendo.data.DataSource({
        name: 'gridDataSource',
        page: 1,
        pageSize: 10,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.efsDomain}/efs/manage/payment`,
            type: 'GET',
            contentType: 'application/json',
            cache: false,
          },
          parameterMap: function (options, operation) {

            if (operation === 'read') {

              let filters = vm.searchFilterParam()
              let sort = EtnersEfsUtil.convertJSONArrayToJSON('sort', options.sort)

              vm.lastRouteParams = {
                loginUserToken: vm.$store.state.loginStore.lutk,
                skip: options.skip,
                take: options.take,
                page: options.page,
                pageSize: options.pageSize,
                ...sort,
                ...filters
              }
              return vm.lastRouteParams
            }

            if (operation !== 'read' && options.models) {
              return { models: kendo.stringify(options.models) }
            }
          },
        },
        schema: {
          type: 'json',
          parse: function (response) {
            let changeResultData = response.resultData
            let rowNumber = (vm.$refs.gridRef.dataSource.page() - 1)
                * vm.$refs.gridRef.dataSource.pageSize()
            for (let i = 0; i < changeResultData?.length; i++) {
              let row = changeResultData[i]
              // row 번호 셋팅
              row.rowNumber = response.total - rowNumber++
            }
            response.resultData = changeResultData
            return response
          },
          total: function (response) {
            return response.total
          },
          data: function (response) {
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            }else if(response.resultStatus.messageCode === '4154'){
              vm.$store.dispatch('LOGOUT').then(() => {
                kendo.alert(response.resultStatus.messageText).bind('close', function() {
                  window.location.href = `/login`
                })
              })
            }else {
              kendo.alert( response.resultStatus.messageText)
              return ''
            }
          },
        },

        error: function (e) {
          console.log('error event handler', e.errors[0])
        },
      })
      return gridDataSource
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name === 'ServiceRequestManageDetail'){
        vm.$refs.gridRef.kendoWidget()?.dataSource.read()
      }
    })
  },
  created () {
    const vm = this
  },
  mounted () {},
  methods: {
    onClickPayment : function (){
      const vm = this
      if(validator()){
        let params = {
          cmpyCd : vm.paymentCmpyCd,
          yyyymm : EtnersDateTimeUtil.dateToYYYYMM(vm.paymentDtVModel),
        }
        ApiUtil.post(`${ApiConfig.efsDomain}/efs/manage/payment`, params).then(response => {

          if (response.data.resultStatus.messageCode === '2000') {
            vm.$refs.paymentWindowRef.kendoWidget().close()
            vm.commonOnChangeEvent()
          } else {
            kendo.alert( response.data.resultStatus.messageText)
            return false
          }
        })
      }

      function validator(){
        if(EtnersCommonUtil.isEmpty(vm.paymentCmpyCd)){
          kendo.alert("회사를 선택해주세요.").bind('close',function (){
            vm.$refs.paymentCmpyCdRef.widget().toggle()
          })
          return false
        }
        if(EtnersCommonUtil.isEmpty(vm.paymentDtVModel)){
          kendo.alert("정산년월을 선택해주세요.").bind('close',function (){
            vm.$refs.paymentDtRef.kendoWidget().open()
          })
          return false
        }
        return true
      }
    },
    cleanSearchDataEvent: function (ev) {
      const refs = this.$refs

      /**
       * 회사명
       * */
      refs.cmpyNmRef.value = ''
      this.commonOnChangeEvent()

    },
    searchFilterParam: function () {
      let searchFilterOptions = {}
      const refs = this.$refs

      //회사명
      const cmpyNm = refs.cmpyNmRef.value
      if (cmpyNm) {searchFilterOptions.searchCmpyNm = cmpyNm}

      return searchFilterOptions ?? undefined
    },
    onChangeGrid (ev) {
      const vm = this
      let cellIdx = window.event.target.cellIndex
      let boolForg = window.event.target.className === 'forg' // 키워드 강조 span태그 클릭시에도 deatil로 이동
      if (!isNaN(cellIdx) || boolForg) {
        let selectedRow = ev.sender.select()
        let rowData = ev.sender.dataItem(selectedRow)
        getPaymentDetailInfo(rowData)
      }

      function getPaymentDetailInfo(rowData){
        ApiUtil.query(`${ApiConfig.efsDomain}/efs/manage/payment/${rowData.billNo}`).then(response => {

          if (response.data.resultStatus.messageCode === '2000') {
            let resultData = response.data.resultData
            let totalAmount = 0
            resultData.forEach((item,i)=>{
              totalAmount += item.finalAmount
            })
            vm.$set(vm.paymentDetailInfo, 'amountList', resultData)
            vm.paymentDetailInfo.totalAmount = totalAmount
            vm.$refs.paymentDetailInfoWindowRef.kendoWidget().center().open()
          } else {
            vm.paymentDetailInfo = {
              amountList : [],
              totalAmount : 0,
            }
            kendo.alert( response.data.resultStatus.messageText)
            return false
          }
        })
      }
    },
    commonOnChangeEvent: function () {
      const gridRef = this.$refs.gridRef
      gridRef?.kendoWidget()?.dataSource?.query({
        sort: {},
        take: 10,
        page:  1,
        pageSize:  10,
      })
    },
    onClickExcelDownload: function(e) {

      const vm = this
      vm.lastRouteParams.requestType = 'EXPORT'
      ApiUtil.query(`${ApiConfig.efsDomain}/efs/manage/payment`, vm.lastRouteParams).then(response => {

        if (response.data.resultStatus.messageCode === '2000') {
          let resultData = response.data.resultData
          if(EtnersCommonUtil.isNotEmpty(resultData) && resultData.length > 0) {

            let goodsListGridColumns = vm.gridColumns.reduce((acc, cur) => {
              if(cur.field !== 'rowNumber'){ acc.push({ ...cur, width : '120px' }) }
              return acc;
            }, []);

            saveExcel({
              data: resultData,
              fileName: '서비스 이용내역목록_' + EtnersDateTimeUtil.dateToYYYYMMDD(new Date()) + '.xlsx',
              columns: goodsListGridColumns
            })
          } else {
            kendo.alert('다운로드 할 자료가 없습니다.')
          }
        } else {
          kendo.alert( response.data.resultStatus.messageText)
          return false
        }
      })
    },
  },
  data () {
    const headerAttributes = { style: 'font-weight: bold; text-align: center;' }
    const centerAttributes = { style: 'text-align: center;' }
    const rightAttributes = { style: 'text-align: right;' }
    return {
      Constant,
      ApiConfig : ApiConfig,
      isPaymentWindowOpen : false,
      isPaymentDetailInfoWindowOpen : false,
      paymentCmpyCd : '',
      paymentDtVModel : '',
      paymentDetailInfo : {},
      constant : {
        svcGrade : {
          standard : '01'
        }
      },
      lastRouteParams : {},
      gridColumns: [
        {
          field: 'rowNumber',
          title: 'No',
          width: '3%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          sortable: false
        },
        {
          field: 'cmpyNm',
          title: '회사명',
          width: '15%',
          headerAttributes: headerAttributes,
        },
        {
          field: 'payDt',
          title: '결제 일시',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'billMm',
          title: '이용 내역',
          width: '10%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'payTypeNm',
          title: '거래방법',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'totAmount',
          title: '거래금액',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes : rightAttributes,
          template: function (dataItem) {
            return EtnersCommonUtil.numberWithCommas(dataItem.totAmount) + ' 원'
          }
        },
        {
          field: 'payStatusNm\t',
          title: '거래상태',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes : centerAttributes
        },
        {
          field: 'payer',
          title: '결제자',
          width: '10%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes
        },
        {
          field: 'billPubYn',
          title: '영수증',
          width: '8%',
          headerAttributes: headerAttributes,
          attributes: centerAttributes,
          template: function (dataItem) {
            return dataItem.billPubYn === 'Y' ? '발급' : '미발급'
          },
        }
      ],
    }
  },
}
</script>
